import React, {
  useEffect,
  useState,
  useContext,
  useCallback,
  useRef,
} from "react";
import dayjs from "dayjs";
import { debounce } from "lodash";

//MUI
import styled from "@emotion/styled";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Chip from "@mui/material/Chip";
import TimelineIcon from "@mui/icons-material/Timeline";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";
import Popover from "@mui/material/Popover";

//icons
import { ReactComponent as ProjectIcon } from "../../assets/project_icon.svg";
import { ReactComponent as PropertyIcon } from "../../assets/property_icon.svg";
import { ReactComponent as AssigneeIcon } from "../../assets/assignee_icon.svg";
import { ReactComponent as ActionIcon } from "../../assets/action_icon.svg";
import { ReactComponent as TagIcon } from "../../assets/tag_icon.svg";
import { ReactComponent as FormatIcon } from "../../assets/format_icon.svg";
import { ReactComponent as AttachmentsIcon } from "../../assets/attachments_icon.svg";
import { ReactComponent as FacebookIcon } from "../../assets/facebook_icon.svg";
import { ReactComponent as PublishIcon } from "../../assets/send_icon.svg";
import { ReactComponent as DropDownIcon } from "../../assets/dropdown_icon.svg";
import { ReactComponent as InstagramIcon } from "../../assets/instagram_icon.svg";
import { ReactComponent as YouTubeIcon } from "../../assets/youtube.svg";

//components
import CustomTextField from "../Common/CustomTextField";
import BasicDatePicker from "../Common/DatePicker";
import AutoCompleteSelect from "../Common/AutoComplete/AutoCompleteSelect";
import AutoCompleteStatusSelect from "../Common/AutoComplete/AutoCompleteStatusSelect";
import AutoCompleteMultiUserSelect from "../Common/AutoComplete/AutoCompleteMultiUserSelect";
import CustomButton from "../Common/CustomButton";
import FileAttachmentsDialog from "./FileAttachmentsDialog";
import TaskHistoryDialog from "./TaskHistoryDialog";
import ShowAttachments from "./ShowAttatchments";
import ConfirmDelete from "./ConfirmDelete";
import PublishContentDialog from "./PublishContentDialog";
import CustomToolTip from "../Common/CustomToolTip";

//apis
import {
  getCohortList,
  getFormatList,
  getStatusList,
  getAttachmentsList,
  addComment,
  getCommentsList,
  deleteComment,
} from "../../apis/taskManagement";
import { getProjectUsersList } from "../../apis/users";
import { getPropertyList } from "../../apis/data";

//context
import { DataContext } from "../../contexts/DataContext";
import { AuthContext } from "../../contexts/AuthContext";
import { AlertContext } from "../../contexts/AlertContext";

//api
import { addTask } from "../../apis/taskManagement";

//assests
import DefaultThumbnail from "../../assets/images/thumbnail1.png";

import EmojiPicker from "emoji-picker-react";
import { Box } from "@mui/material";

export const LinkifyText = (text) => {
  // Regex matches links starting with http, https, or www.
  const urlRegex = /((https?:\/\/)|(www\.))[^\s]+/g;
  const parts = [];
  let lastIndex = 0;
  let match;
  let keyIndex = 0;

  while ((match = urlRegex.exec(text)) !== null) {
    // Add text before the match
    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index));
    }
    const url = match[0];
    // If the URL doesn't start with http(s), prepend it so the link works correctly
    const href = url.startsWith("http") ? url : `http://${url}`;
    parts.push(
      <a key={keyIndex} href={href} target="_blank" rel="noopener noreferrer">
        {url}
      </a>
    );
    keyIndex++;
    lastIndex = match.index + url?.length;
  }

  // Add any remaining text after the last match
  if (lastIndex < text?.length) {
    parts.push(text.substring(lastIndex));
  }
  return <>{parts}</>;
};
const OuterContainer = styled("div")(({ theme }) => ({
  width: "100%",
  "& .button_container": {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "1rem",
    padding: "0.5rem 1rem",
    borderTop: "1px solid #EAEAEA",
    "& .button_style": {
      background: "#253A6A",
    },
  },
  "& .attachments_comments": {
    display: "flex",
    padding: "0 1rem",
    "& .left_area": {
      width: "60%",
    },
    "& .right_area": {
      width: "40%",
      display: "flex",
      "& .empty_block": {
        width: "20%",
      },
      "& .button_block": {
        width: "80%",
      },
    },
  },
}));

const MidContainer = styled("div")(({ theme }) => ({
  height: "370px",
  overflowY: "scroll",
  overflowX: "hidden",
  paddingBottom: 0,
  "&::-webkit-scrollbar": {
    width: "0.4em",
  },
  "&::-webkit-scrollbar-track": {
    boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "gray",
    borderRadius: "30px",
  },
  "& .comment_script": {
    padding: "0 1rem",
    display: "flex",
    width: "100%",
    "& .left": {
      width: "50%",
      "& .edit_button_style": {
        display: "flex",
        justifyContent: "flex-end",
        "& .edit_comm_style": {
          height: "22px",
          fontSize: "11px",
        },
      },
    },
    "& .right": {
      width: "50%",
      "& .edit_button_style": {
        display: "flex",
        justifyContent: "flex-end",
        "& .edit_comm_style": {
          height: "22px",
          fontSize: "11px",
        },
      },
    },
    "& .comments_container": {
      height: "200px",
      border: "1px solid #E5E5E5",
      overflowY: "scroll",
      overflowX: "hidden",
      "&::-webkit-scrollbar": {
        width: "0.4em",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#9A9A9A",
        borderRadius: "30px",
      },
      "& .comment_block": {
        margin: "0.5rem",
        borderBottom: "1px solid #C4C4C4",
        paddingBottom: "0.5rem",
        "& .header_style_script": {
          marginBottom: "0.5rem",
          "& .header_with_edit": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            "& .headers_style": {
              display: "flex",
              gap: "0.5rem",
              alignItems: "center",
            },
          },
          "& .MuiAvatar-root": {
            height: "32px",
            width: "32px",
            fontSize: "14px",
          },
          "& .name_style": {
            color: "#1B1C1E",
            fontWeight: "600",
            fontSize: "16px",
          },
          "& .date_style": {
            color: "#939090",
            fontSize: "14px",
          },
        },
        "& .header_style_script_old": {
          marginBottom: "0.5rem",
          overflow: "hidden",
          "& .header_with_edit": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            "& .headers_style": {
              display: "flex",
              gap: "0.5rem",
              alignItems: "center",
            },
          },
          "& .MuiAvatar-root": {
            height: "32px",
            width: "32px",
            fontSize: "14px",
          },
          "& .name_style": {
            color: "#1B1C1E",
            fontWeight: "600",
            fontSize: "16px",
          },
          "& .date_style": {
            color: "#939090",
            fontSize: "14px",
          },
        },
        "& .comment_style": {
          color: "#67727E",
          fontSize: "16px",
        },
        "& .link_style": {
          color: "blue",
          fontSize: "16px",
          "&:hover": {
            color: "red",
          },
        },
      },
    },
  },
}));

const Container = styled("div")(({ theme, totalAttachments }) => ({
  padding: "1rem 1rem 0 1rem",
  display: "flex",
  gap: "2rem",
  "& .left_container": {
    width: "60%",
    // background: "pink",
    "& .option_container": {
      display: "flex",
      alignItems: "center",
      marginBottom: "0.7rem",
    },
    "& .option_container_caption": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginBottom: "0rem",
    },
    "& .chips_container": {
      display: "flex",
      flexDirection: "column",
      gap: "0.2rem",
      marginBottom: "0.7rem",
      "& .chip_text": {
        color: "#4F4F4F",
        fontSize: "12px",
        fontWeight: "500",
      },
    },
    "& .option_container_new": {
      display: "flex",
      alignItems: "center",
      marginBottom: "0.2rem",
    },
    "& .add_comm": {
      width: "84%",
      // background: "cyan",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "flex-start",
      "& .MuiButton-root": {
        padding: "0 0.5rem",
      },
    },
    "& .option_name": {
      width: "0%",
      fontSize: "16px",
      color: "#4F4F4F",
      [theme.breakpoints.down("xl")]: {
        fontSize: "14px",
      },
    },
    "& .option_input": {
      width: "100%",
      display: "flex",
      gap: "0.5rem",
      "& .MuiInputBase-root": {
        height: "36px",
      },
      "& textarea": {
        border: "1px solid #b3b3b3",
        borderRadius: "4px",
        fontFamily: theme.typography.fontFamily,
        "&:focus": {
          outlineColor: "#00A0E3",
        },
      },
      "& .comment_style_container": {
        width: "92%",
        border: "1px solid #E5E5E5",
        borderRadius: "4px",
        padding: "0.3rem",
        "& .comment_style": {
          width: "90%",
          color: "#4F4F4F",
          fontSize: "13px",
        },
      },
    },
    "& .option_input_comm": {
      width: "100%",
      display: "flex",
      "& .empty_span": {
        width: "8%",
      },
      "& .MuiInputBase-root": {
        height: "36px",
      },
      "& textarea": {
        border: "1px solid #00A0E3",
        borderRadius: "4px",
        padding: "0.3rem",
        fontFamily: theme.typography.fontFamily,
        "&:focus": {
          outlineColor: "#00A0E3",
        },
      },
    },
    "& .option_input_member": {
      width: "100%",
      display: "flex",
      gap: "0.5rem",
      "& .css-1kkal6p-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
        {
          // padding: 0,
        },
      "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-1kkal6p-MuiAutocomplete-root .MuiOutlinedInput-root":
        {
          // padding: 0,
        },
      "& .css-1kkal6p-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input":
        {
          // padding: "0 0 0 7px",
          height: "36px",
        },
    },
    "& .chips_style": {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      gap: "0.2rem",
    },
    "& .option_input_date": {
      width: "90%",
      display: "flex",
      gap: "0.5rem",
      "& .MuiInputBase-root": {
        height: "40px",
      },
      "& .MuiInputBase-input": {
        paddingTop: "3px",
        paddingBottom: "3px",
      },
      "& .MuiButtonBase-root": {
        // height: "36px",
        padding: 0,
      },
    },
    "& .attatchments_container": {
      height: "145px",
      width: "85%",
      display: "flex",
      gap: "0.5rem",
      marginBottom: "0.7rem",
      "& .attachment_platform_block": {
        display: "flex",
        flexDirection: "column",
        borderRadius: "6px",
        boxShadow: "0px 0px 4px 0px #00000029",
        "& .platform_info": {
          height: "25px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "0.4rem",
          "& svg": {
            height: "16px",
            width: "16px",
          },
          "& .platform_txt": {
            color: "#787575",
            fontSize: "14px",
          },
        },
      },
      "& .img_style": {
        height: "100px",
        width: "100px",
        objectFit: "cover",
        borderRadius: "4px",
        border: "1px solid #EAEAEA",
        cursor: "pointer",
      },
    },
    "& .comments_scripts_container": {
      width: "100%",
      "& .tabs": {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "& .tab": {
          width: "50%",
          borderRadius: 0,
          paddingLeft: "16px",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          borderBottom: "1px solid #E5E5E5",
          "& .tab_text": {
            color: "#1B1C1E",
            fontSize: "14px",
            fontWeight: "600",
          },
        },
        "& .selected_tab": {
          borderBottom: "2px solid #00A0E3",
        },
      },
      "& .comments_container": {
        width: "100%",
        height: totalAttachments ? "260px" : "360px",
        // border: "1px solid red",
        overflowY: "scroll",
        overflowX: "hidden",
        "&::-webkit-scrollbar": {
          width: "0.4em",
        },
        "&::-webkit-scrollbar-track": {
          boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
          webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#E5E5E5",
          borderRadius: "30px",
        },
        "& .new_comm_script": {
          width: "100%",
          padding: "0.5rem 0.2rem 0.5rem 0",
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          "& .avt_container": {
            width: "8%",
            paddingLeft: "0.5rem",
            alignSelf: "flex-start",
            "& .MuiAvatar-root": {
              height: "32px",
              width: "32px",
              fontSize: "14px",
            },
          },
          "& textarea": {
            border: "1px solid #b3b3b3",
            borderRadius: "4px",
            fontFamily: theme.typography.fontFamily,
            "&:focus": {
              outlineColor: "#00A0E3",
            },
          },
        },
        "& .comment_block": {
          width: "100%",
          padding: "0.5rem 0.2rem 0.5rem 0.5rem",
          // borderBottom: "1px solid #C4C4C4",
          // paddingBottom: "0.5rem",
          "& .header_style_script": {
            marginBottom: "0.5rem",
            "& .header_with_edit": {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              "& .headers_style": {
                display: "flex",
                gap: "0.5rem",
                alignItems: "center",
              },
            },
            "& .MuiAvatar-root": {
              height: "32px",
              width: "32px",
              fontSize: "14px",
            },
            "& .name_style": {
              color: "#1B1C1E",
              fontWeight: "600",
              fontSize: "16px",
            },
            "& .date_style": {
              color: "#939090",
              fontSize: "14px",
            },
          },
          "& .header_style_script_old": {
            // display: "flex",
            // gap: "1rem",
            // alignItems: "center",
            marginBottom: "1px",
            overflow: "hidden",
            "& .header_with_edit": {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              "& .headers_style": {
                display: "flex",
                gap: "0.5rem",
                alignItems: "center",
              },
            },
            "& .MuiAvatar-root": {
              height: "32px",
              width: "32px",
              fontSize: "14px",
            },
            "& .name_style": {
              color: "#1B1C1E",
              fontWeight: "600",
              fontSize: "16px",
            },
            "& .date_style": {
              color: "#939090",
              fontSize: "14px",
            },
          },
          "& .edit_button_style": {
            // can be removed
            display: "flex",
            justifyContent: "flex-end",
            "& .edit_comm_style": {
              height: "22px",
              fontSize: "11px",
            },
          },
          "& .comments_display_container": {
            width: "100%",
            display: "flex",
            // gap: "0.5rem",
            "& .empty_span": {
              width: "8%",
            },
            "& .comment_style_container": {
              width: "92%",
              border: "1px solid #E5E5E5",
              borderRadius: "4px",
              padding: "0.3rem",
              "& .comment_style": {
                width: "90%",
                color: "#4F4F4F",
                fontSize: "13px",
              },
            },
          },
          "& .comment_actions_container": {
            width: "100%",
            display: "flex",
            // gap: "0.5rem",
            paddingTop: "0.3rem",
            "& .empty_span": {
              width: "8%",
            },
            "& .btns_container": {
              display: "flex",
              gap: "8px",
              "& .edit_btn": {
                padding: "0 3px 3px 0",
                minWidth: "40px",
                display: "flex",
                justifyContent: "flex-start",
              },
              "& .del_btn": {
                padding: "0 3px 3px 0",
                minWidth: "50px",
                display: "flex",
                justifyContent: "flex-start",
              },
              "& .btn_txt": {
                color: "#787575",
                fontSize: "13px",
                fontWeight: "400",
              },
            },
          },
          "& .link_style": {
            color: "blue",
            fontSize: "16px",
            "&:hover": {
              color: "red",
            },
          },
        },
      },
    },
  },
  "& .right_container": {
    width: "40%",
    // background: "cyan",
    "& .option_container": {
      display: "flex",
      alignItems: "center",
      marginBottom: "1.3rem",
      justifyContent: "flex-end",
    },
    "& .option_container_caption": {
      display: "flex",
      flexDirection: "column",
      marginBottom: "1.3rem",
      justifyContent: "flex-end",
      "&.emoji-picker-container h2": {
        fontSize: " 14px !important;",
      },
    },
    "& .action_button_preview": {
      width: "100%",
      border: "1px solid #E5E5E5",
      background: "#F5F5F5",
      display: "flex",
      justifyContent: "flex-start",
      paddingLeft: "8px",
      // gap: "0.5rem",
      "& .MuiButton-startIcon, & .btn_text": {
        display: "flex",
        alignItems:
          "center" /* Align startIcon and text in the center vertically */,
        gap: "0.5rem" /* Spacing between startIcon and text */,
      },
      "& .MuiButton-endIcon": {
        marginLeft: "auto" /* Pushes endIcon to the right */,
        "& svg": {
          height: "16px",
          width: "16px",
        },
      },
      "& .btn_text_preview": {
        color: "#253A6A",
        fontWeight: "500",
        fontSize: "14px",
      },
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        "& .btn_text_preview": {
          color: "#fff",
        },
        "& .MuiButton-startIcon svg path": {
          stroke: "#fff"
        },
      },
    },
    "& .action_button": {
      width: "100%",
      border: "1px solid #E5E5E5",
      display: "flex",
      justifyContent: "flex-start",
      paddingLeft: "4px",
      gap: "0.5rem",
      "& .btn_text": {
        color: "#4F4F4F",
        fontWeight: "400",
        fontSize: "14px",
      },
    },
    "& .option_name": {
      width: "0%",
      fontSize: "16px",
      color: "#4F4F4F",
      [theme.breakpoints.down("xl")]: {
        fontSize: "14px",
      },
    },
    "& .option_input": {
      width: "100%",
      display: "flex",
      gap: "0.5rem",
      "& .comment_style_container": {
        width: "100%",
        border: "1px solid rgb(179,179,179)",
        borderRadius: "4px",
        padding: "0.3rem",
        "& .comment_style": {
          width: "90%",
          color: "black",
          fontSize: "13px",
        },
      },

      "& .MuiInputBase-root": {
        height: "36px",
        width: "100%",
      },
      "& textarea": {
        border: "1px solid #b3b3b3",
        borderRadius: "4px",
        padding: "0.3rem 0.5rem",
        fontFamily: theme.typography.fontFamily,
        "&:focus": {
          outlineColor: "#00A0E3",
        },
      },
      "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.MuiAutocomplete-root .MuiOutlinedInput-root":
        {
          padding: 0,
          paddingRight: "56px",
        },
      "& .css-1kkal6p-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input":
        {
          padding: "0 0 0 7px",
          height: "36px",
        },
      "& svg": {
        paddingLeft: "5px",
      },
    },
    "& .option_input_action": {
      width: "100%",
      display: "flex",
      gap: "0.5rem",
      "& .MuiInputBase-root": {
        height: "36px",
        width: "100%",
      },
      "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.MuiAutocomplete-root .MuiOutlinedInput-root":
        {
          padding: 0,
          paddingRight: "56px",
        },
      "& .css-1kkal6p-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input":
        {
          padding: "0 0 0 7px",
          height: "36px",
        },
      // "& .css-1kkal6p-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input": {
      //   padding: "0 0 0 7px",
      //   height: "36px",
      // },
      "& svg": {
        paddingLeft: "5px",
      },
    },
    "& .option_input_member": {
      width: "100%",
      display: "flex",
      gap: "0.5rem",
      "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.MuiAutocomplete-root .MuiOutlinedInput-root":
        {
          padding: 0,
          paddingRight: "56px",
        },
      "& .css-1kkal6p-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input":
        {
          padding: "0 0 0 7px",
          height: "36px",
        },
      "& svg": {
        paddingLeft: "5px",
      },
    },
  },
}));

const platformMapping = {
  facebook: "Facebook",
  instagram: "Instagram",
  youtube: "YouTube",
};

const initialState = {
  id: "",
  topic: "",
  postLink: "",
  igPostLink: "",
  ytPostLink: "",
  due_date: new Date(),
  caption: "",
  members: "",
  approvers: "",
  state: null,
  project: { id: "", name: "" },
  property: { id: "", name: "" },
  cohort: { id: "", name: "" },
  format: { id: "", name: "" },
  category: null,
  action: { id: 1, status: "Planned" },
};

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  const initials = name
    .split(" ")
    .map((word) => word[0])
    .join("");
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: initials,
  };
}

const isValidUrl = (urlString) => {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};

const CreateTask = ({
  handleClose,
  modalData,
  action,
  modalProps,
  handleEdit,
  handleUpdate,
}) => {
  const [state, setState] = useState(initialState);
  const [usersList, setUsersList] = useState([]);
  const [approversList, setApproversList] = useState([]);
  const [cohortList, setCohortList] = useState([]);
  const [formatList, setFormatList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedMembersCompleteInfo, setSelectedMembersCompleteInfo] =
    useState([]);
  const [selectedApprovers, setSelectedApprovers] = useState([]);
  const [selectedApproversCompleteInfo, setSelectedApproversCompleteInfo] =
    useState([]);
  const [totalAttachments, setTotalAttachments] = useState("");
  const [open, setOpen] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);
  const [openAttachment, setOpenAttachment] = useState(false);
  const [openPublish, setOpenPublish] = useState(false);
  const [selectedAttachment, setSelectedAttachment] = useState("");
  const [selectedAttachmentInfo, setSelectedAttachmentInfo] = useState("");
  const [attachmentPlatform, setAttachmentPlatform] = useState("");
  const [script, setScript] = useState("");
  const [comment, setComment] = useState("");
  const [commentsData, setCommentsData] = useState([]);
  const [datePickerKey, setDatePickerKey] = useState(0);
  const [propertyList, setPropertyList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [commentAction, setCommentAction] = useState(false);
  const [commentId, setCommentId] = useState("");
  const [editCommentVal, setEditCommentVal] = useState("");
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [commentToDelete, setCommentToDelete] = useState("");
  const [commentToDeleteType, setCommentToDeleteType] = useState("");
  const [userPageCount, setUserPageCount] = useState(0);
  const [userCurrentPage, setUserCurrentPage] = useState(1);
  const [userLoadType, setUserLoadType] = useState("initial");
  const [tabSeledted, setTabSelected] = useState("comment");
  const [editTopic, setEditTopic] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [captionEdit, setCaptionEdit] = useState(false);
  const { projectList } = useContext(DataContext);
  const { user } = useContext(AuthContext);
  const { showAlert } = useContext(AlertContext);

  const emojiPickerRef = useRef(null);

  // Handle outside click to close emoji picker
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickConfirmDelete = (val, type) => {
    setCommentToDelete(val);
    setCommentToDeleteType(type);
    setOpenConfirmDelete(true);
  };

  const handleDialogCloseConfirmDelete = () => {
    setOpenConfirmDelete(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickOpenHistory = () => {
    setOpenHistory(true);
  };

  const handleClickOpenAttachment = () => {
    setOpenAttachment(true);
  };

  const handleClickOpenPublish = () => {
    setOpenPublish(true);
  };

  const handleDialogClose = (value) => {
    setOpen(false);
  };

  const handleDialogCloseHistory = (value) => {
    setOpenHistory(false);
  };

  const handleDialogCloseAttachment = (value) => {
    setOpenAttachment(false);
  };

  const handleClickClosePublish = (value) => {
    setOpenPublish(false);
  };

  const getUsersData = async (proj, prop, mem = "", loadType, currPage) => {
    // setUsersList([]);
    const { data, error } = await getProjectUsersList(
      user.pk,
      proj?.id ? [proj?.id] : [],
      prop?.id ? [prop?.id] : [],
      mem,
      currPage
    );
    if (error) {
      if (error.status === 401) {
        return;
      } else if (error.status === 404) {
        // alert("No users available for your state");
        return;
      } else {
        // alert("Couldn't fetch the data");
        return;
      }
    }
    // setUsersList(data);
    let newData;
    if (loadType === "initial") {
      setUserPageCount(Math.ceil(data.count / 20));
      newData = [...data.results];
      setUserLoadType("");
    } else {
      newData = [...usersList, ...data.results];
    }
    setUserCurrentPage((prevPage) => prevPage + 1);
    setUsersList(newData);
    let approvers = newData.filter((user) => user.is_approver);
    setApproversList(approvers);
  };

  const getCohortData = async () => {
    const { data, error } = await getCohortList();
    if (error) {
      if (error.status === 401) {
        return;
      } else if (error.status === 404) {
        // alert("No users available for your state");
        return;
      } else {
        // alert("Couldn't fetch the data");
        return;
      }
    }
    setCohortList(data);
  };

  const getFormatData = async () => {
    const { data, error } = await getFormatList();
    if (error) {
      if (error.status === 401) {
        return;
      } else if (error.status === 404) {
        // alert("No users available for your state");
        return;
      } else {
        // alert("Couldn't fetch the data");
        return;
      }
    }
    setFormatList(data);
  };

  const getStatusData = async () => {
    const { data, error } = await getStatusList();
    if (error) {
      if (error.status === 401) {
        return;
      } else if (error.status === 404) {
        // alert("No users available for your state");
        return;
      } else {
        // alert("Couldn't fetch the data");
        return;
      }
    }
    setStatusList(data);
  };

  const getAttachmentsData = async (
    id,
    type = "",
    attach_id = "",
    status,
    socialPlatform
  ) => {
    if (id) {
      const { data, error } = await getAttachmentsList(
        id,
        type,
        attach_id,
        status
      );
      if (error) {
        if (error.status === 401) {
          return;
        } else if (error.status === 404) {
          // alert("No users available for your state");
          return;
        } else {
          // alert("Couldn't fetch the data");
          return;
        }
      }
      if (type === "del") {
        showAlert("File deleted successfully", "success");
        return;
      }
      if (type === "edit") {
        showAlert("File status changed successfully", "success");
        return;
      }
      let platformKeys = Object.keys(data);
      if (platformKeys.length) {
        setTotalAttachments(data);
        if (attach_id && socialPlatform) {
          setAttachmentPlatform(socialPlatform);
          setSelectedAttachment(
            data[`${socialPlatform}`][0]?.file_urls.length
              ? data[`${socialPlatform}`][0]?.file_urls[0]
              : ""
          );
          setSelectedAttachmentInfo(data[`${socialPlatform}`][0]);
          return socialPlatform;
        }
        setAttachmentPlatform(platformKeys[0]);
        setSelectedAttachment(
          data[`${platformKeys[0]}`][0]?.file_urls.length
            ? data[`${platformKeys[0]}`][0]?.file_urls[0]
            : ""
        );
        setSelectedAttachmentInfo(data[`${platformKeys[0]}`][0]);
        return platformKeys[0];
      } else {
        setTotalAttachments("");
        setSelectedAttachment("");
        setSelectedAttachmentInfo("");
      }
    }
  };

  const getCommentsData = async (id) => {
    if (id) {
      const { data, error } = await getCommentsList(id);
      if (error) {
        if (error.status === 401) {
          return;
        } else if (error.status === 404) {
          // alert("No users available for your state");
          return;
        } else {
          // alert("Couldn't fetch the data");
          return;
        }
      }
      setCommentsData(data);
    }
  };

  const getDropDownData = async (id) => {
    getCohortData();
    getFormatData();
    getStatusData();
    // getCategoryData();
    getAttachmentsData(id);
    getCommentsData(id);
  };

  const handleMembersChange = (data, text) => {
    if (text === "approvers") {
      if (data.length > 0) {
        let ids = data.map((item) => item.pk);
        setSelectedApproversCompleteInfo(data);
        setSelectedApprovers(ids);
      } else {
        setSelectedApproversCompleteInfo([]);
        setSelectedApprovers([]);
      }
    } else {
      if (data.length > 0) {
        let ids = data.map((item) => item.pk);
        setSelectedMembersCompleteInfo(data);
        setSelectedMembers(ids);
      } else {
        setSelectedMembersCompleteInfo([]);
        setSelectedMembers([]);
      }
    }
  };

  const handleCommentAction = (val) => {
    if (val === "") {
      setCommentAction(false);
      setCommentId("");
      setEditCommentVal("");
      return;
    }
    setCommentAction((prevState) => !prevState);
    setCommentId(val?.id);
    setEditCommentVal(val?.text);
  };

  // check here //
  const handleCommentDelete = async () => {
    const { error } = await deleteComment(state.id, commentToDelete?.id);
    if (error) {
      showAlert("Something went wrong", "error");
      return;
    }
    if (commentToDeleteType === "script") {
      showAlert("Script Deleted", "success");
    } else {
      showAlert("Comment Deleted", "success");
    }
    getCommentsData(state.id);
    setCommentToDelete("");
    setCommentToDeleteType("");
    handleDialogCloseConfirmDelete();
  };

  //debounced function for delaying the api call
  const debounceFunction = useCallback(
    debounce((...eventData) => {
      setUserPageCount(0);
      setUserCurrentPage(1);
      setUserLoadType("initial");
      getUsersData(...eventData);
    }, 500),
    []
  );

  const onInputChange = (event, value) => {
    if (value) {
      debounceFunction(state.project, state.property, value, "initial", 1);
    } else {
      debounceFunction(state.project, state.property, "", "initial", 1);
    }
  };

  const getPropertyData = async (proj) => {
    if (user) {
      const { result, err } = await getPropertyList(proj?.id ? [proj?.id] : []);
      if (err) {
        alert("Couldn't fetch the data");
        return;
      }
      setPropertyList(result);
    }
  };

  const handleChange = (data, text) => {
    if (!data) {
      if (text === "action") {
        setState((prevState) => ({
          ...prevState,
          [`${text}`]: { id: "", status: "" },
        }));
      } else {
        if (text === "project") {
          setState((prevState) => ({
            ...prevState,
            [`${text}`]: { id: "", name: "" },
            property: { id: "", name: "" },
          }));
          setPropertyList([]);
        } else {
          setState((prevState) => ({
            ...prevState,
            [`${text}`]: { id: "", name: "" },
          }));
          if (text === "property") {
            setUsersList([]);
          }
        }
      }
    }
    if (text === "action") {
      if (data) {
        if (
          action === "create" &&
          (data.status === "Approved" || data.status === "Shared")
        ) {
          showAlert(
            "You cannot create a task at Approved or Shared state directly",
            "error"
          );
          return;
        }
        if (!user?.is_admin) {
          if (user?.role[0].name === "Video Editor") {
            if (
              data.status === "Pending" ||
              data.status === "Scripting Approved" ||
              data.status === "Under Graphic Edit" ||
              data.status === "Voice over Artist" ||
              data.status === "Under Video Edit" ||
              data.status === "Under Img/Video Review"
            ) {
              setState((prevState) => ({
                ...prevState,
                [`${text}`]: data,
              }));
            } else {
              showAlert("You are not authorized to make this change", "error");
            }
          } else if (user?.role[0].name === "Content Writer") {
            setState((prevState) => ({
              ...prevState,
              [`${text}`]: data,
            }));
          } else if (user?.role[0].name === "Voice over Artist") {
            if (
              data.status === "Pending" ||
              data.status === "Scripting Approved" ||
              data.status === "Under Graphic Edit" ||
              data.status === "Voice over Artist" ||
              data.status === "Under Video Edit" ||
              data.status === "Under Img/Video Review"
            ) {
              setState((prevState) => ({
                ...prevState,
                [`${text}`]: data,
              }));
            } else {
              showAlert("You are not authorized to make this change", "error");
            }
          } else if (user?.role[0].name === "Graphic Designer") {
            if (
              data.status === "Pending" ||
              data.status === "Scripting Approved" ||
              data.status === "Under Graphic Edit" ||
              data.status === "Under Video Edit" ||
              data.status === "Under Img/Video Review"
            ) {
              setState((prevState) => ({
                ...prevState,
                [`${text}`]: data,
              }));
            } else {
              showAlert("You are not authorized to make this change", "error");
            }
          } else {
            showAlert("You are not authorized to make this change", "error");
          }
        } else {
          setState((prevState) => ({
            ...prevState,
            [`${text}`]: data,
          }));
        }
      }
    } else {
      if (data) {
        if (text === "project") {
          setUserCurrentPage(1);
          setUserPageCount(0);
          setState((prevState) => ({
            ...prevState,
            [`${text}`]: data,
            property: { id: "", name: "" },
          }));
          if (propertyList.length > 0) {
            setPropertyList([]);
          }
          getPropertyData(data);
          setUserCurrentPage(1);
          setUserPageCount(0);
          getUsersData(data, "", "", "initial", 1);
        } else {
          setState((prevState) => ({
            ...prevState,
            [`${text}`]: data,
          }));
          if (text === "property") {
            setUserCurrentPage(1);
            setUserPageCount(0);
            getUsersData(state?.project, data, "", "initial", 1);
          }
        }
      }
    }
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    if (name === "postLink") {
      if (value.length >= 8) {
        if (!value.startsWith("https://")) {
          showAlert("Post Link should be a link", "error");
          return;
        }
      }
    }
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const onEmojiClick = (emojiData) => {
    const emoji = emojiData.emoji;
    setState((prevState) => ({
      ...prevState,
      caption: (prevState.caption || "") + emoji,
    }));
  };

  const handleDateChange = (val) => {
    if (action === "edit") {
      const date = new Date(modalData?.due_at);
      if (date > val?.[`$d`]) {
        showAlert("Due cannot be before the created date", "error");
        setState((prevState) => ({
          ...prevState,
          due_date: modalData?.due_at,
        }));
        setDatePickerKey((prevKey) => prevKey + 1);
      } else {
        setState((prevState) => ({
          ...prevState,
          due_date: val?.[`$d`],
        }));
        setDatePickerKey((prevKey) => prevKey + 1);
      }
    } else {
      const date = new Date();
      if (date > val?.[`$d`]) {
        showAlert("Due cannot be before the created date", "error");
        setState((prevState) => ({
          ...prevState,
          due_date: date,
        }));
        setDatePickerKey((prevKey) => prevKey + 1);
      } else {
        setState((prevState) => ({
          ...prevState,
          due_date: val?.[`$d`],
        }));
        setDatePickerKey((prevKey) => prevKey + 1);
      }
    }
  };

  const handleDelete = (data, type) => {
    if (!user.is_admin && user?.role[0].name !== "Content Writer") {
      showAlert("You are not authorized to make this change", "error");
      return;
    }
    if (
      state?.[`${type}`].length === 1 &&
      (type === "approvers"
        ? selectedApprovers.length === 0
        : selectedMembers.length === 0)
    ) {
      showAlert(
        `Atleast one member needs to be assigned ${
          type === "approvers" ? "as an approver" : ""
        } to the task`,
        "error"
      );
      return;
    }
    const newData = state?.[`${type}`].filter((item) => item?.pk !== data?.pk);
    if (newData.length > 0) {
      setState((prevState) => ({
        ...prevState,
        [`${type}`]: newData,
      }));
      return;
    }
    setState((prevState) => ({
      ...prevState,
      [`${type}`]: "",
    }));
  };

  const handleImageClick = (e, item, platform) => {
    e.stopPropagation();
    handleClickOpenAttachment();
    setAttachmentPlatform(platform);
    setSelectedAttachment(item.file_urls[0]);
    setSelectedAttachmentInfo(item);
  };

  const handleFinalCommentSubmit = async (type) => {
    let text = "";
    if (type === "script") {
      text = script;
    } else {
      text = comment;
    }
    let action = "create";
    if (commentAction) {
      action = "edit";
      text = editCommentVal;
    }
    const { error } = await addComment(state.id, text, type, action, commentId);
    if (error) {
      showAlert("Something went wrong", "error");
      return;
    }
    if (type === "script") {
      showAlert(
        `${!commentAction ? "Script Added" : "Script Edited"}`,
        "success"
      );
    } else {
      showAlert(
        `${!commentAction ? "Comment Added" : "Comment Edited"}`,
        "success"
      );
    }
    if (type === "script") {
      setScript("");
    } else {
      setComment("");
    }
    if (commentAction) {
      setCommentAction(false);
      setCommentId("");
      setEditCommentVal("");
    }
    getCommentsData(state.id);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    let membersData = "";
    //for removing duplicate members on edit
    if (state.members) {
      let ids = state.members.map((item) => item.pk);
      membersData = [...new Set([...selectedMembers, ...ids])];
    } else {
      if (selectedMembers) {
        let createdId = [user?.pk];
        membersData = [...new Set([...selectedMembers, ...createdId])];
      }
    }

    let approversData = "";
    //for removing duplicate approvers on edit
    if (state.approvers) {
      let ids = state.approvers.map((item) => item.pk);
      approversData = [...new Set([...selectedApprovers, ...ids])];
    } else {
      if (selectedApprovers) {
        approversData = selectedApprovers;
      }
    }

    if (state.postLink) {
      if (!isValidUrl(state.postLink)) {
        showAlert("Post Link should be a valid url", "error");
        setLoader(false);
        return;
      }
    }

    const { error, message } = await addTask(
      state.id,
      state.topic,
      state.postLink,
      state.due_date,
      state.caption,
      state.cohort,
      state.format,
      state.category,
      state.action,
      membersData,
      approversData,
      state.state,
      state.project,
      state.property,
      action,
      state.igPostLink,
      state.ytPostLink,
    );

    if (error) {
      if (error === 403) {
        showAlert(message, "error");
        setLoader(false);
        return;
      }
      showAlert(error, "error");
      setLoader(false);
      return;
    }
    if (action === "edit") {
      showAlert("Task Updated", "success");
    } else {
      showAlert("Task Created", "success");
    }
    setLoader(false);
    modalProps.handleRefresh(!modalProps.refreshList);
    handleClose();
  };

  useEffect(() => {
    if (modalData) {
      setState({
        id: modalData?.id || "",
        topic: modalData?.title || "",
        postLink: modalData?.post_link || "",
        igPostLink: modalData?.ig_post_link || "",
        ytPostLink: modalData?.yt_post_link || "",
        due_date: modalData?.due_at ? new Date(modalData?.due_at) : "",
        caption: modalData?.description || "",
        members: modalData?.assigned_to || "",
        approvers: modalData?.approvers_data || "",
        state: modalData?.state || null,
        project: modalData?.project || { id: "", name: "" },
        property: modalData?.property || { id: "", name: "" },
        cohort: modalData?.cohort_data || { id: "", name: "" },
        format: modalData?.format_data || { id: "", name: "" },
        category: modalData?.category_data || null,
        action: modalData?.status_data || { id: 1, status: "Planned" },
      });
      getPropertyData(modalData?.project);
      getUsersData(
        modalData?.project,
        modalData?.property,
        "",
        userLoadType,
        userCurrentPage
      );
    }
    getDropDownData(modalData?.id);
  }, []);
  return (
    <OuterContainer>
      <form onSubmit={handleSubmit}>
        <MidContainer>
          <Container
            totalAttachments={totalAttachments.length > 0 ? true : false}
          >
            <div className="left_container">
              <div className="option_container">
                {/* <span className="option_name">Topic</span> */}
                <div className="option_input">
                  {!editTopic && action !== "create" ? (
                    <CustomToolTip
                      title="Click to edit"
                      placement="top"
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "common.black",
                            "& .MuiTooltip-arrow": {
                              color: "common.black",
                            },
                          },
                        },
                      }}
                    >
                      <Typography
                        onClick={() => {
                          setEditTopic(true);
                        }}
                        sx={{
                          color: "#303030",
                          fontWeight: "600",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                      >
                        {state.topic}
                      </Typography>
                    </CustomToolTip>
                  ) : (
                    <></>
                  )}
                  {(action === "edit" && editTopic) || action === "create" ? (
                    <CustomTextField
                      value={state.topic}
                      name="topic"
                      label="Enter Topic"
                      variant="outlined"
                      color="secondary"
                      onChange={handleTextChange}
                      sx={{ width: "100%" }}
                      radius="4px"
                      required
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div className="chips_container">
                <div className="chip_text">Assignee(s):</div>
                <div className="chips_style">
                  {action === "edit" && state.members ? (
                    state.members.map((item) => {
                      return (
                        <Chip
                          key={item.id}
                          label={item.name}
                          onDelete={() => handleDelete(item, "members")}
                          sx={{
                            background: "#ECF0FC",
                            color: "#1B1C1E",
                            fontSize: "12px",
                            fontWeight: "500",
                          }}
                        />
                      );
                    })
                  ) : (
                    <></>
                  )}
                  {selectedMembersCompleteInfo.length ? (
                    selectedMembersCompleteInfo.map((item) => {
                      return (
                        <Chip
                          key={item?.pk}
                          label={item?.name}
                          // onDelete={() => handleDelete(item)}
                          sx={{
                            background: "#fff9e6",
                            color: "#1B1C1E",
                            fontSize: "12px",
                            fontWeight: "500",
                          }}
                        />
                      );
                    })
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div className="chips_container">
                <span className="chip_text">Approver(s):</span>
                <div className="chips_style">
                  {action === "edit" && state.approvers ? (
                    state.approvers.map((item) => {
                      return (
                        <Chip
                          key={item.id}
                          label={item.name}
                          onDelete={() => handleDelete(item, "approvers")}
                          sx={{
                            background: "#ECF0FC",
                            color: "#1B1C1E",
                            fontSize: "12px",
                            fontWeight: "500",
                          }}
                        />
                      );
                    })
                  ) : (
                    <></>
                  )}
                  {selectedApproversCompleteInfo.length ? (
                    selectedApproversCompleteInfo.map((item) => {
                      return (
                        <Chip
                          key={item?.pk}
                          label={item?.name}
                          // onDelete={() => handleDelete(item)}
                          sx={{
                            background: "#fff9e6",
                            color: "#1B1C1E",
                            fontSize: "12px",
                            fontWeight: "500",
                          }}
                        />
                      );
                    })
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              {action === "edit" && state?.action?.status === "Shared" ? (
                <div className="option_container">
                  {/* <span className="option_name">Post Link</span> */}
                  <div className="option_input">
                    <CustomTextField
                      value={state.postLink}
                      name="postLink"
                      label="Enter Post Link"
                      variant="outlined"
                      color="secondary"
                      onChange={handleTextChange}
                      radius="4px"
                      sx={{ width: "100%" }}
                    />
                  </div>
                </div>
              ) : (
                <></>
              )}

              {action === "edit" && state?.action?.status === "Shared" ? (
                <div className="option_container">
                  {/* <span className="option_name">Post Link</span> */}
                  <div className="option_input">
                    <CustomTextField
                      value={state.igPostLink}
                      name="igPostLink"
                      label="IG Account Link"
                      variant="outlined"
                      color="secondary"
                      onChange={handleTextChange}
                      radius="4px"
                      sx={{ width: "100%" }}
                    />
                  </div>
                </div>
              ) : (
                <></>
              )}

              {/* {action === "edit" && state?.action?.status === "Shared" ? (
                <div className="option_container">
                  <div className="option_input">
                    <CustomTextField
                      value={state.ytPostLink}
                      name="ytPostLink"
                      label="YouTube Post Link"
                      variant="outlined"
                      color="secondary"
                      onChange={handleTextChange}
                      radius="4px"
                      sx={{ width: "100%" }}
                    />
                  </div>
                </div>
              ) : (
                <></>
              )} */}

              <div className="option_container">
                {/* <span className="option_name_date">Due Date</span> */}
                <div className="option_input_date">
                  <BasicDatePicker
                    size="small"
                    key={datePickerKey}
                    placeholder="Due date"
                    sx={{
                      width: "60%",
                    }}
                    label="Due Date"
                    val={state.due_date}
                    onChange={handleDateChange}
                  />
                </div>
              </div>

              {totalAttachments ? (
                <div className="attatchments_container">
                  {Object.keys(totalAttachments).map((key) => {
                    return (
                      <div className="attachment_platform_block">
                        <div
                          style={{
                            position: "relative",
                            height: "120px",
                            width: "120px",
                            backgroundImage: `url(${
                              /\.mp4/.test(
                                totalAttachments[`${key}`][0]?.file_urls[0]
                              )
                                ? DefaultThumbnail
                                : totalAttachments[`${key}`][0]?.file_urls[0]
                            })`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            backgroundSize: "cover",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            borderTopLeftRadius: "6px",
                            borderTopRightRadius: "6px",
                          }}
                          onClick={(e) =>
                            handleImageClick(
                              e,
                              totalAttachments[`${key}`][0],
                              key
                            )
                          }
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              height: "100%",
                              width: "100%",
                              filter: "blur(4px)",
                            }}
                          ></div>
                          <Typography
                            sx={{
                              position: "relative",
                              zIndex: 1,
                              fontSize: "18px",
                              fontWeight: "600",
                              color: "#FFFFFF",
                            }}
                          >
                            {totalAttachments[`${key}`]?.length > 1
                              ? `${totalAttachments[`${key}`]?.length}+`
                              : `${totalAttachments[`${key}`]?.length}`}
                          </Typography>
                        </div>
                        <div className="platform_info">
                          {key === "facebook" ? (
                            <FacebookIcon />
                          ) : key === "instagram" ? (
                            <InstagramIcon />
                          ) : (
                            <YouTubeIcon />
                          )}
                          <Typography className="platform_txt">
                            {platformMapping[`${key}`]}
                          </Typography>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <></>
              )}

              {action === "edit" ? (
                <div className="comments_scripts_container">
                  <div className="tabs">
                    <CustomButton
                      className={
                        tabSeledted === "comment" ? `tab selected_tab` : "tab"
                      }
                      onClick={() => setTabSelected("comment")}
                    >
                      <Typography className="tab_text">Comments</Typography>
                    </CustomButton>
                    <CustomButton
                      className={
                        tabSeledted === "script" ? `tab selected_tab` : "tab"
                      }
                      onClick={() => setTabSelected("script")}
                    >
                      <Typography className="tab_text">Script</Typography>
                    </CustomButton>
                  </div>
                  <div className="comments_container">
                    <div className="new_comm_script">
                      <div className="avt_container">
                        <Avatar {...stringAvatar(`${user?.name}`)} />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          gap: "3px",
                        }}
                      >
                        <TextareaAutosize
                          minRows={2}
                          style={{
                            width: "100%",
                            padding: "0.3rem",
                          }}
                          name={tabSeledted}
                          value={tabSeledted === "script" ? script : comment}
                          placeholder={`Add a new ${tabSeledted}...`}
                          onChange={
                            tabSeledted === "script"
                              ? (e) => setScript(e.target.value)
                              : (e) => setComment(e.target.value)
                          }
                          // onClick={() => handleFinalCommentSubmit(tabSeledted)}
                          // onKeyDown={handleCommentSubmit}
                        />
                        <CustomButton
                          variant="text"
                          onClick={() => handleFinalCommentSubmit(tabSeledted)}
                          sx={{
                            padding: "0 3px 3px 0",
                            minWidth: "40px",
                            width: "40px",
                          }}
                        >
                          <Typography
                            sx={{
                              color: "#787575",
                              fontSize: "13px",
                              fontWeight: "400",
                              textTransform: "none",
                            }}
                          >
                            Add
                          </Typography>
                        </CustomButton>
                      </div>
                    </div>
                    {commentsData.map((item) => {
                      if (item.type === tabSeledted) {
                        return (
                          <div className="comment_block">
                            <div className="header_style_script_old">
                              <div className="header_with_edit">
                                <div className="headers_style">
                                  <Avatar
                                    {...stringAvatar(
                                      `${item?.posted_by?.name}`
                                    )}
                                  />
                                  <Typography className="name_style">
                                    {item?.posted_by?.name}
                                  </Typography>
                                  <Typography className="date_style">
                                    {dayjs(item?.created_at).format(
                                      "DD-MMM-YYYY"
                                    )}
                                  </Typography>
                                </div>
                              </div>
                            </div>
                            {commentAction && commentId === item?.id ? (
                              <>
                                <div className="option_input_comm">
                                  <span className="empty_span"></span>
                                  <TextareaAutosize
                                    minRows={3}
                                    style={{
                                      width: "92%",
                                    }}
                                    name="comment"
                                    value={editCommentVal}
                                    onChange={(e) =>
                                      setEditCommentVal(e.target.value)
                                    }
                                    // onKeyDown={handleCommentSubmit}
                                  />
                                </div>
                              </>
                            ) : (
                              <div className="comments_display_container">
                                <span className="empty_span"></span>
                                <div className="comment_style_container">
                                  <Typography className="comment_style">
                                    {LinkifyText(item?.text)}
                                  </Typography>
                                </div>
                              </div>
                            )}
                            <div className="comment_actions_container">
                              <span className="empty_span"></span>
                              <div className="btns_container">
                                {commentAction && commentId === item?.id ? (
                                  <CustomButton
                                    className="edit_btn"
                                    onClick={() =>
                                      handleFinalCommentSubmit(tabSeledted)
                                    }
                                  >
                                    <Typography className="btn_txt">
                                      Save Changes
                                    </Typography>
                                  </CustomButton>
                                ) : (
                                  <CustomButton
                                    onClick={() => handleCommentAction(item)}
                                    className="edit_btn"
                                  >
                                    <Typography className="btn_txt">
                                      Edit
                                    </Typography>
                                  </CustomButton>
                                )}
                                {/* {commentAction && commentId === item?.id ?
                                <CustomCancelButton
                                  handleClick={() => handleCommentAction("")}
                                /> :
                                <></>
                              } */}
                                {commentId !== item?.id ? (
                                  <CustomButton
                                    onClick={() =>
                                      handleClickConfirmDelete(
                                        item,
                                        tabSeledted
                                      )
                                    }
                                    className="del_btn"
                                  >
                                    <Typography className="btn_txt">
                                      Delete
                                    </Typography>
                                  </CustomButton>
                                ) : (
                                  <CustomButton
                                    onClick={() => handleCommentAction("")}
                                    className="del_btn"
                                  >
                                    <Typography className="btn_txt">
                                      Discard
                                    </Typography>
                                  </CustomButton>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>

            <div className="right_container">
              {action === "edit" &&
              user &&
              state?.action?.status === "Approved" &&
              user?.is_superuser ? (
                <div className="option_container">
                  <span className="option_name"></span>
                  <div className="option_input">
                    <CustomButton
                      startIcon={<PublishIcon />}
                      variant="outlined"
                      onClick={handleClickOpenPublish}
                      className="action_button_preview"
                      sx={{
                        textTransform: "none",
                        "& svg": {
                          height: "22px",
                          width: "22px",
                        },
                      }}
                    >
                      <Typography className="btn_text_preview">
                        Publish & Preview
                      </Typography>
                    </CustomButton>
                  </div>
                </div>
              ) : (
                <></>
              )}

              <div className="option_container">
                {/* <span className="option_name">Project</span> */}
                <div className="option_input">
                  <FormControl sx={{ width: "100%" }}>
                    <AutoCompleteSelect
                      size="small"
                      label="Select Project"
                      value={state.project}
                      options={projectList}
                      color="secondary"
                      text="project"
                      onChange={handleChange}
                      leftIcon={ProjectIcon}
                      // disabled={user?.role.length < 2 ? true : false}
                      required
                    />
                  </FormControl>
                </div>
              </div>

              <div className="option_container">
                {/* <span className="option_name">Property</span> */}
                <div className="option_input">
                  <Tooltip
                    title={
                      !state?.project?.id ? "Please select a project first" : ""
                    }
                  >
                    <FormControl sx={{ width: "100%" }}>
                      <AutoCompleteSelect
                        size="small"
                        label="Select Property"
                        value={state.property}
                        options={propertyList}
                        text="property"
                        color="secondary"
                        onChange={handleChange}
                        disabled={!state?.project?.id}
                        leftIcon={PropertyIcon}
                        required
                      />
                    </FormControl>
                  </Tooltip>
                </div>
              </div>

              <div className="option_container">
                {/* <span className="option_name">Assignee</span> */}
                <div className="option_input_member">
                  <Tooltip
                    title={
                      !state?.property?.id
                        ? "Please select a property first"
                        : ""
                    }
                  >
                    <FormControl sx={{ width: "100%" }}>
                      <AutoCompleteMultiUserSelect
                        size="small"
                        label="Select Assignee(s)"
                        limitTags={1}
                        // value={state.members}
                        leftIcon={AssigneeIcon}
                        onInputChange={onInputChange}
                        options={usersList}
                        text="approver"
                        color="secondary"
                        onChange={handleMembersChange}
                        disabled={!state?.property?.id}
                        loadType={userLoadType}
                        currentPage={userCurrentPage}
                        pageCount={userPageCount}
                        getUsersData={getUsersData}
                        project={state?.project}
                        property={state?.property}
                        required={
                          action === "edit"
                            ? false
                            : selectedMembers.length
                            ? false
                            : true
                        }
                      />
                    </FormControl>
                  </Tooltip>
                </div>
              </div>

              <div className="option_container">
                {/* <span className="option_name">Assignee</span> */}
                <div className="option_input_member">
                  <Tooltip
                    title={
                      !state?.property?.id
                        ? "Please select a property first"
                        : ""
                    }
                  >
                    <FormControl sx={{ width: "100%" }}>
                      <AutoCompleteMultiUserSelect
                        size="small"
                        label="Select Approver(s)"
                        limitTags={1}
                        // value={state.members}
                        leftIcon={AssigneeIcon}
                        onInputChange={onInputChange}
                        options={approversList}
                        text="approvers"
                        color="secondary"
                        onChange={handleMembersChange}
                        disabled={!state?.property?.id}
                        loadType={userLoadType}
                        currentPage={userCurrentPage}
                        pageCount={userPageCount}
                        getUsersData={getUsersData}
                        project={state?.project}
                        property={state?.property}
                        required={
                          action === "edit"
                            ? false
                            : selectedApprovers.length
                            ? false
                            : true
                        }
                      />
                    </FormControl>
                  </Tooltip>
                </div>
              </div>

              <div className="option_container_caption">
                {/* <span className="option_name">Caption</span> */}
                <div className="option_input">
                  {state?.caption === "" || captionEdit ? (
                    <TextareaAutosize
                      minRows={4}
                      style={{
                        width: "100%",
                      }}
                      name="caption"
                      color="secondary"
                      placeholder="Enter Caption"
                      value={state?.caption}
                      onChange={handleTextChange}
                      onFocus={() => setCaptionEdit(true)}
                      onBlur={() => setCaptionEdit(false)}
                    ></TextareaAutosize>
                  ) : (
                    <div className="comment_style_container">
                      <Typography
                        className="comment_style"
                        onClick={() => setCaptionEdit(true)}
                      >
                        {LinkifyText(state?.caption)}
                      </Typography>
                    </div>
                  )}
                </div>
                {!showEmojiPicker && (
                  <CustomButton
                    onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                    sx={{
                      minWidth: "40px",
                      width: "40px",
                      padding: "0",
                      ml: "auto",
                    }}
                  >
                    😊
                  </CustomButton>
                )}
                {showEmojiPicker && (
                  <Box
                    sx={{
                      "& h2": {
                        fontSize: "14px !important",
                      },
                    }}
                    ref={emojiPickerRef}
                  >
                    <EmojiPicker
                      searchDisabled
                      onEmojiClick={onEmojiClick}
                      theme="light"
                      className="emoji-picker-container"
                      width={"100%"}
                      style={{
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "5px",
                      }}
                    />
                  </Box>
                )}
              </div>
              <div className="option_container">
                {/* <span className="option_name">Tag</span> */}
                <div className="option_input">
                  <FormControl sx={{ width: "100%" }}>
                    <AutoCompleteSelect
                      size="small"
                      label="Select Tag"
                      value={state.cohort}
                      options={cohortList}
                      text="cohort"
                      color="secondary"
                      onChange={handleChange}
                      leftIcon={TagIcon}
                      required
                    />
                  </FormControl>
                </div>
              </div>
              <div className="option_container">
                {/* <span className="option_name">Format</span> */}
                <div className="option_input">
                  <FormControl sx={{ width: "100%" }}>
                    <AutoCompleteSelect
                      size="small"
                      label="Select Format"
                      value={state.format}
                      options={formatList}
                      text="format"
                      color="secondary"
                      onChange={handleChange}
                      leftIcon={FormatIcon}
                      required
                    />
                  </FormControl>
                </div>
              </div>
              <div className="option_container">
                {/* <span className="option_name">Action</span> */}
                <div className="option_input_action">
                  {action === "edit" ? (
                    <FormControl sx={{ width: "100%" }}>
                      <AutoCompleteStatusSelect
                        size="small"
                        label="Select Action"
                        value={state.action}
                        options={statusList}
                        text="action"
                        color="secondary"
                        onChange={handleChange}
                        leftIcon={ActionIcon}
                        disabled={action !== "edit"}
                        required
                      />
                    </FormControl>
                  ) : (
                    <CustomToolTip
                      title="Task can only be created at Planned stage"
                      placement="top"
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "common.black",
                            "& .MuiTooltip-arrow": {
                              color: "common.black",
                            },
                          },
                        },
                      }}
                    >
                      <FormControl sx={{ width: "100%" }}>
                        <AutoCompleteStatusSelect
                          size="small"
                          label="Select Action"
                          value={state.action}
                          options={statusList}
                          text="action"
                          color="secondary"
                          onChange={handleChange}
                          leftIcon={ActionIcon}
                          disabled={action !== "edit"}
                          required
                        />
                      </FormControl>
                    </CustomToolTip>
                  )}
                </div>
              </div>
              {action === "edit" ? (
                <div className="option_container">
                  <span className="option_name"></span>
                  <div className="option_input">
                    <CustomButton
                      startIcon={<AttachmentsIcon />}
                      variant="outlined"
                      onClick={handleClickOpen}
                      className="action_button"
                    >
                      <Typography className="btn_text">Attachments</Typography>
                    </CustomButton>
                  </div>
                </div>
              ) : (
                <></>
              )}
              {action === "edit" ? (
                <div className="option_container">
                  <span className="option_name"></span>
                  <div className="option_input">
                    <CustomButton
                      startIcon={<TimelineIcon />}
                      variant="outlined"
                      onClick={handleClickOpenHistory}
                      className="action_button"
                      sx={{
                        textTransform: "none",
                        "& svg": {
                          color: "#4F4F4F",
                        },
                      }}
                    >
                      <Typography className="btn_text">Task History</Typography>
                    </CustomButton>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </Container>
        </MidContainer>

        <div className="button_container">
          <CustomButton
            className="button_style"
            variant="contained"
            onClick={handleClose}
          >
            Cancel
          </CustomButton>
          <div>
            {loader ? (
              <CustomButton
                className="button_style"
                variant="contained"
                // onClick={handleSubmit}
                type="submit"
                disabled={true}
                sx={{
                  textTransform: "none",
                  height: "34px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress
                  style={{
                    height: "16px",
                    width: "16px",
                  }}
                />
                <Typography sx={{ fontSize: "10px", color: "#FFF" }}>
                  Please Wait ...
                </Typography>
              </CustomButton>
            ) : (
              <CustomButton
                className="button_style"
                variant="contained"
                // onClick={handleSubmit}
                type="submit"
              >
                {action === "edit" ? "Update" : "Create Task"}
              </CustomButton>
            )}
          </div>
        </div>
      </form>
      {open ? (
        <FileAttachmentsDialog
          open={open}
          onClose={handleDialogClose}
          taskId={state.id}
          getAttachmentsData={getAttachmentsData}
        />
      ) : (
        <></>
      )}
      {openHistory ? (
        <TaskHistoryDialog
          open={openHistory}
          onClose={handleDialogCloseHistory}
          taskId={state.id}
          statusList={statusList}
        />
      ) : (
        <></>
      )}
      {openAttachment ? (
        <ShowAttachments
          open={openAttachment}
          onClose={handleDialogCloseAttachment}
          taskId={state.id}
          attachments={totalAttachments}
          selectedAttachment={selectedAttachment}
          getAttachmentsData={getAttachmentsData}
          selectedAttachmentInfo={selectedAttachmentInfo}
          attachmentPlatform={attachmentPlatform}
        />
      ) : (
        <></>
      )}
      <ConfirmDelete
        open={openConfirmDelete}
        onClose={handleDialogCloseConfirmDelete}
        onConfirm={handleCommentDelete}
        fileType={commentToDeleteType}
      />
      {openPublish ? (
        <PublishContentDialog
          open={openPublish} 
          onClose={handleClickClosePublish}
          attachments={totalAttachments}
          caption={state.caption}
          pageName={state.property}
          taskId={state.id}
          // publishPlatform={publishPlatform}
        />) :
        <></>
      }
    </OuterContainer>
  );
};

export default CreateTask;
